import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';
import { MktCommonModule } from 'src/app/common/mkt-common.module';
import { MktContentStorageService } from 'src/app/core/services/mkt-content-storage.service';

@Component({
  selector: 'app-program-detail-section',
  templateUrl: './program-detail-section.component.html',
  styleUrls: ['./program-detail-section.component.scss'],
  standalone: true,
  imports: [MktCommonModule]
})
export class ProgramDetailSectionComponent implements OnInit, OnDestroy {

  cardDetails: any = null;
  programDetailContent: any = null;
  routeSub: Subscription = new Subscription();
  @Input() contentType='programDetailSection';

  constructor(
    private _mktContentStorageService: MktContentStorageService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.getProgramDetailContent();
  }

  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }

  private getProgramDetailContent() {
    this.routeSub = combineLatest([
      this.route.params,
    ]).subscribe(params => {
      const cardName = params[0]['cardName'].replace(/\./g, '');
      // Try to get card pricing details
      const mainPdpContentObject = this._mktContentStorageService.get('Product_Detail_Pages', 'copy', cardName, undefined);
      if (!mainPdpContentObject[this.contentType]) {
        return;
      }
      this.cardDetails = JSON.parse(mainPdpContentObject['TEXT']);
      this.programDetailContent = JSON.parse(mainPdpContentObject[this.contentType]);
      if (!this.programDetailContent || !this.programDetailContent.isActive) { return; }
    });
  }

}

